/**
 * Highest-degree academic row + year-of-passout parse (pure — no React).
 * Keep in sync with backend/src/domain/student/highestDegreeYear.js.
 */

export const MIN_HIGHEST_DEGREE_YEAR = 1950;
export const MAX_HIGHEST_DEGREE_YEAR = 2100;

export function resolveHighestDegree(student) {
  const quals = student?.academicQualifications;
  if (!Array.isArray(quals) || quals.length === 0) return null;
  const marked = quals.find((q) => q.isHighestDegree);
  return marked || quals[0];
}

export function readHighestDegreeYear(student) {
  const highest = resolveHighestDegree(student);
  if (highest?.yearOfPassout == null || highest.yearOfPassout === '') return null;
  const n = Number(highest.yearOfPassout);
  return Number.isFinite(n) ? n : null;
}

export function parseHighestDegreeYear(value) {
  if (value === undefined || value === null || String(value).trim() === '') {
    return { ok: false, error: 'Year of passout is required' };
  }
  const year = Number(String(value).trim());
  if (!Number.isInteger(year) || year < MIN_HIGHEST_DEGREE_YEAR || year > MAX_HIGHEST_DEGREE_YEAR) {
    return {
      ok: false,
      error: `Year of passout must be a whole number between ${MIN_HIGHEST_DEGREE_YEAR} and ${MAX_HIGHEST_DEGREE_YEAR}`,
    };
  }
  return { ok: true, year };
}

export function isStudentDirectoryRow(row) {
  const type = row?.userType || row?.role;
  return !type || type === 'student';
}
